import createCtx from '../../helpers/createCtx';

export const [useActiveExperiments, ActiveExperimentsContext] =
  createCtx('ActiveExperiments');
